import { TokenMetadata } from '~/hooks/useTokenMetadata'
import { AssetType, OrgAssetTransfer, TransferData } from '~/types'
import { EvmAddress } from '~/utils/address'
import { shortenAddress } from '~/utils/addresses'

interface MinimalNFT {
  assetType: AssetType
  nftAddress?: string
  nftTokenId?: string
  nftName?: string
  nftSymbol?: string
}

export function getTokenRepresentation(
  transfer: OrgAssetTransfer | TransferData | MinimalNFT,
  options: {
    metadata?: Partial<TokenMetadata>
    amount?: string
    showAmount?: boolean
  } = {},
) {
  const { metadata, amount, showAmount } = options
  let assetType: AssetType = AssetType.ERC20

  if (!('id' in transfer)) {
    assetType = transfer.nftAddress
      ? transfer.nftTokenId
        ? AssetType.ERC1155
        : AssetType.ERC721
      : AssetType.ERC20
  } else {
    assetType = transfer.assetType
  }

  let tokenRepresentation = metadata?.symbol ?? 'UNKNOWN TOKEN'

  if (assetType === AssetType.ERC721 || assetType === AssetType.ERC1155) {
    if (transfer.nftName && transfer.nftName !== amount) {
      tokenRepresentation = transfer.nftName
    } else {
      const symbol = transfer.nftSymbol ?? metadata?.symbol ?? 'UNKNOWN NFT'
      tokenRepresentation = EvmAddress.validate(symbol)
        ? shortenAddress(symbol)
        : symbol

      if ('id' in transfer) {
        if (transfer.tokenId) {
          tokenRepresentation += ` #${transfer.tokenId}`
        }
      } else if (transfer.nftTokenId) {
        tokenRepresentation += ` #${transfer.nftTokenId}`
      }
    }
  }

  if (showAmount) {
    tokenRepresentation = `${amount ? amount + ' ' : ''}${tokenRepresentation}`
  }

  return tokenRepresentation
}
